module.exports = __webpack_public_path__ + "static/media/vinohradnicke_stavby.2e2de772.md";